module.exports = __webpack_public_path__ + "static/media/Quarter.a5e944fb.png";